var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('catalogue-provider',{attrs:{"product-types":_vm.productTypes,"handle-loading":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var $catalogueData = ref.$catalogueData;
return [(!$catalogueData.isLoading)?[_c('product-search',{attrs:{"id":"WHPT1","available-modes":_vm.availableModes,"manual-filters":{
          'filter[provision_category.code]': _vm.categoryCode
        },"show-tree-view":false}})]:_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }